// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__32pdo","colMin":"styles_colMin__BaMJx","colCheckbox":"styles_colCheckbox__1V47w"};